import { render, staticRenderFns } from "./DetailReceipt.vue?vue&type=template&id=073a77f4&"
import script from "./DetailReceipt.vue?vue&type=script&lang=js&"
export * from "./DetailReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073a77f4')) {
      api.createRecord('073a77f4', component.options)
    } else {
      api.reload('073a77f4', component.options)
    }
    module.hot.accept("./DetailReceipt.vue?vue&type=template&id=073a77f4&", function () {
      api.rerender('073a77f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/DetailReceipt.vue"
export default component.exports